/**
 * @file 缓存相关的 hooks
 */
import { useLocalStorageState as useLocalStorageStateOriginal } from 'ahooks';
/**
 * 获取和存储数据至 localeStorage
 * 文档：https://ahooks.js.org/zh-CN/hooks/use-local-storage-state
 *
 * @category State Hook
 */
export const useLocalStorageState = useLocalStorageStateOriginal;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RvcmFnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9zdG9yYWdlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBRUgsT0FBTyxFQUFFLG9CQUFvQixJQUFJLDRCQUE0QixFQUFFLE1BQU0sUUFBUSxDQUFBO0FBRTdFOzs7OztHQUtHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sb0JBQW9CLEdBQUcsNEJBQTRCLENBQUEifQ==